var _line, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlecheCtAretour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 7,
    viewBox: "0 0 22 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3.5,
    x2: 22,
    y2: 3.5,
    stroke: "#AFC700"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1.5299e-07 3.5L5.25 6.53109L5.25 0.468911L-1.5299e-07 3.5Z",
    fill: "#AFC700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlecheCtAretour);
export default __webpack_public_path__ + "static/media/flèche CTA retour.0ff015b87dead99019e59cbf81331d11.svg";
export { ForwardRef as ReactComponent };